import script from "./NewNotificationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NewNotificationItem.vue?vue&type=script&setup=true&lang=js"

import "./NewNotificationItem.vue?vue&type=style&index=0&id=04262196&lang=css"

const __exports__ = script;

export default __exports__